import { render, staticRenderFns } from "./scrollView.vue?vue&type=template&id=914fb3d2&scoped=true"
import script from "./scrollView.vue?vue&type=script&lang=js"
export * from "./scrollView.vue?vue&type=script&lang=js"
import style0 from "./scrollView.vue?vue&type=style&index=0&id=914fb3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914fb3d2",
  null
  
)

export default component.exports